import { Reveal, Overline } from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  ["¿Necesito local u oficina física?", "No. El modelo Kairós es 100% digital. Toda la operación —CRM, campañas, contenido y atención— corre sobre plataforma. No hay renta, obra ni inventario físico."],
  ["¿Necesito experiencia previa en educación?", "No es indispensable. El producto educativo, los materiales y los procesos vienen listos. Buscamos perfil de operador o inversionista con capacidad de ejecución, no docentes."],
  ["¿Cuánto capital necesito para invertir?", "Depende del territorio y el país. Es significativamente menor que una franquicia tradicional porque no financia local ni inventario. En la llamada de precalificación revisamos las cifras exactas de tu mercado."],
  ["¿Quién genera los clientes?", "La adquisición de demanda se hace con pauta en Meta Ads gestionada de forma centralizada por nuestro equipo. Tú operas y conviertes; nosotros alimentamos el flujo."],
  ["¿Qué significa que los territorios son limitados?", "Asignamos un número acotado de licencias por zona y país para proteger la demanda de cada franquiciatario. Cuando un territorio se ocupa, se cierra la convocatoria para esa zona."],
  ["¿Qué recibo al firmar la licencia?", "Acceso a la plataforma y al CRM, las campañas activas para tu territorio, el contenido educativo, la capacitación y soporte continuo del equipo central."],
];

export function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-14">
          <Reveal className="lg:col-span-4">
            <Overline>Preguntas frecuentes</Overline>
            <h2 className="font-serif text-4xl sm:text-5xl font-bold tracking-tight text-midnight mt-6 leading-[1.05]">
              Lo que todo inversionista pregunta.
            </h2>
          </Reveal>

          <div className="lg:col-span-8">
            <Reveal delay={0.1}>
              <Accordion type="single" collapsible className="w-full border-t border-midnight/10" data-testid="faq-accordion">
                {FAQS.map(([q, a], i) => (
                  <AccordionItem key={i} value={`item-${i}`} className="border-b border-midnight/10">
                    <AccordionTrigger
                      data-testid={`faq-trigger-${i}`}
                      className="font-serif text-xl sm:text-2xl text-midnight hover:text-crimson hover:no-underline text-left py-6"
                    >
                      {q}
                    </AccordionTrigger>
                    <AccordionContent className="font-sans text-base font-light text-midnight/60 leading-relaxed pb-6 pr-4">
                      {a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
